<template>

  <v-footer>
      
      <v-container id="links">

        <v-row>
          <v-col>
              <p>Did you like it? Do you want to know more about it? Would you like to try it out on your data?</p>
              <p>If so, feel free to leave a comment on our <a href="https://www.linkedin.com/company/machine-learning-reply">LinkedIn page</a> or check out our <a href="https://www.reply.com/machine-learning-reply">website</a> and contact us!</p>
          </v-col>
        </v-row>

        <v-divider></v-divider> 

        <v-row>
          <v-col>
            2020 - Machine Learning Reply
          </v-col>
        </v-row>

      </v-container>

  </v-footer>

</template>

<script>

export default {
  name: 'Footer'  
}

</script>

<style scoped>

#links {
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
  margin: auto;
  text-align: center;
}

p {
  margin-bottom: 0;
}

</style>
